import React, { createContext, useContext, useState, useCallback } from 'react';

const NavbarSlotCtx = createContext(null);

export const NavbarSlotProvider = ({ children }) => {
  const [slot, setSlot] = useState(null);
  const setNavbarSlot = useCallback((node) => setSlot(node), []);
  return (
    <NavbarSlotCtx.Provider value={{ slot, setNavbarSlot }}>
      {children}
    </NavbarSlotCtx.Provider>
  );
};

// Used by dashboard views to inject content into the Navbar
export const useNavbarSlot = () => {
  const ctx = useContext(NavbarSlotCtx);
  if (!ctx)
    throw new Error('useNavbarSlot must be used inside NavbarSlotProvider');
  return ctx.setNavbarSlot;
};

// Used by NavbarComponent to read the injected content
export const useNavbarSlotContent = () =>
  useContext(NavbarSlotCtx)?.slot ?? null;
